export default __webpack_public_path__ + "img/4478f70b8f75e3ccdde3f8e72441e7ca.svg";